// Router.js
import React, { useEffect } from "react";
import { useRoutes, Navigate, useNavigate } from "react-router-dom";

import LoginPage from "../LoginPage/Loginpage";
import Page1 from "../Page1/page1";
import LayoutPage from "../LayoutPage/LayoutPage";
import Dashboard from "../DashBoard/Dashboard";
import DashPage1 from "../DashBoard/DashboardPages/DashPage1/DashPage1";
import DashPage2 from "../DashBoard/DashboardPages/DashPage2/DashPage2";
import DashPage3 from "../DashBoard/DashboardPages/DashPage3/DashPage3";
import TermsPrivacy from "../TermsandPrivacy/TermsandPrivacy";

export default function Router() {
  const routes = useRoutes([
    {
      path: "",
      element: <LayoutPage />,
    },

    {
      path: "dashboard",
      element: <Dashboard />,
      children: [
        { element: <Navigate to="apiKeys" />, index: true },
        {
          path: `apiKeys`,
          element: <DashPage1 />,
        },
        {
          path: `profile`,
          element: <DashPage2 />,
        },
        {
          path: `docs`,
          element: <DashPage3 />,
        },
      ],
    },
    {
      path: "login",
      element: <LoginPage />,
    },
    {
      path: "docsv2",
      element: <DocsVTwo />,
    },
    {
      path: "docsv3",
      element: <DocsVThree />,
    },
    {
      path: "termsprivacy",
      element: <TermsPrivacy />,
    },
  ]);

  return routes;
}

const DocsVTwo = () => {
  useEffect(() => {
    window.location.href = "./docsv2/index.html";
  }, []);
  return <></>;
};
const DocsVThree = () => {
  useEffect(() => {
    window.location.href = "./docsv3/docs/get-started/packages-instalation";
  }, []);
  return <></>;
};
